import BaseApi from './base'

class BOVersion extends BaseApi {
  getBOVersions = (query) => this.client.get(`admin/bo-versions?${query}`)

  addBOVersion = (data) => this.client.post('admin/bo-versions', data)

  updateBOVersion = (id, data) =>
    this.client.patch(`admin/bo-versions/${id}`, data)

  deleteBOVersion = (id) => this.client.delete(`admin/bo-versions/${id}`)
}

export default new BOVersion()
